import {Navigate} from 'react-router';

import useFormContext from '@/hooks/useFormContext';
import useQueryParams from '@/hooks/useQueryParams';

const FormLandingPage: React.FC = () => {
  const {introductionPageContent = '', type} = useFormContext();
  const {preserveQueryParams} = useQueryParams();

  let startPageUrl: string;
  if (type === 'single_step') {
    startPageUrl = 'sp';
  } else {
    startPageUrl = introductionPageContent ? 'introductie' : 'startpagina';
  }

  const targetUrl = preserveQueryParams(startPageUrl);
  return <Navigate replace to={targetUrl} />;
};

export default FormLandingPage;
